import { isBlank } from "./perfilForm";

export function validatePerfil(form) {
    const errores = {};

    if (isBlank(form.tipoDocumento)) errores.tipoDocumento = "Selecciona un tipo de documento.";

    if (!/\S+@\S+\.\S+/.test(form.email) && form.email !== "") errores.email = "Email inválido";
    if (!/\S+@\S+\.\S+/.test(form.emailContacto) && form.emailContacto !== "")
        errores.emailContacto = "Email inválido";

    if (!/^\+\d{1,3} ?\d{6,14}$/.test(form.telefono) && form.telefono !== "")
        errores.telefono = "Teléfono inválido. Ej: +34 612345678";

    if (!/^\+\d{1,3} ?\d{6,14}$/.test(form.telefonoContacto) && form.telefonoContacto !== "")
        errores.telefonoContacto = "Teléfono inválido. Ej: +34 612345678";

    (form.licenciasArmas || []).forEach((lic, index) => {
        if (!isBlank(lic.tipo)) {
            const esIndefinida = !!lic.fechaIndefinida;
            const sinFechaValidez = isBlank(lic.fechaValidez);

            if (!esIndefinida && sinFechaValidez) {
                errores[`licenciasArmas_fechaValidez_${index}`] =
                    "Indica una fecha de validez o marca la casilla de 'indefinida'.";
            }
        }
    });

    return errores;
}
